"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configLang = exports.EndpointEnv = void 0;
var _Constants = require("./Constants");
const configLang = exports.configLang = {
  ch: {
    code: 'de',
    name: 'Deutsch',
    short: 'De',
    localString: 'de-CH',
    currency: 'CHF',
    address: {
      name: 'Brixel AG',
      adr: ['Ernastrasse 22, 8004 Zurich, Switzerland']
    },
    social: {
      facebook: 'https://www.facebook.com/brixel.ch/',
      instagram: 'https://www.instagram.com/brixel_hq/',
      twitter: 'https://twitter.com/brixel_hq',
      linkedin: 'https://www.linkedin.com/company/brixel-ag/'
    },
    convertUnit: {
      sqm: 'm2'
    }
  },
  en: {
    code: 'en',
    name: 'English',
    short: 'En',
    localString: 'en-GB',
    currency: 'EUR',
    convertUnit: {
      sqm: 'm2'
    }
  },
  io: {
    code: 'en',
    name: 'English',
    short: 'En',
    localString: 'en-GB',
    currency: 'EUR',
    address: {
      name: 'Brixel AG',
      adr: ['Ernastrasse 22, 8004 Zurich, Switzerland']
    },
    social: {
      facebook: 'https://www.facebook.com/brixel.ch/',
      instagram: 'https://www.instagram.com/brixel_hq/',
      twitter: 'https://twitter.com/brixel_hq',
      linkedin: 'https://www.linkedin.com/company/brixel-ag/'
    },
    convertUnit: {
      sqm: 'm2'
    }
  }
};
const EndpointEnv = exports.EndpointEnv = {
  dev: {
    aboutUsLink: 'https://brixel.io/about-us',
    apiPath: 'https://dev.api.brixel.io',
    apiRoot: 'https://dev.api.brixel.io/api/v3',
    baseURL: 'https://dev-',
    buyUrl: 'https://brixel.ch/kaufen/',
    buyUrlDe: 'https://brixel.ch/kaufen/',
    craftCMS: 'https://dev-cms.brixel.ch/',
    dashboardPath: 'https://dev-hub.brixel.io',
    editorPath: 'https://dev-dashboard.brixel.io',
    env: 'dev',
    estimationUrl: 'https://brixel.io/bewerten/',
    googleLocation: 'https://maps.googleapis.com/maps/api/geocode',
    googleMaps: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    googleMapsGeocoderKey: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    hideLog: false,
    homepageUrl: 'https://brixel.ch/',
    hubUrl: 'https://dev-hub.brixel.io/',
    languages: _Constants.languagesList,
    loginBasePath: 'https://dev-login.brixel.io',
    loginUrl: 'https://dev-login.brixel.io/login',
    logoutUrl: 'https://dev-login.brixel.io/logout',
    marketUrl: 'https://dev-market.brixel.io',
    mixpanelId: '460b9387e3ff8b54da7bd974141e0f02',
    pageUrl: 'https://dev-page.brixel.io/',
    priceGuarantee: 'https://brixel.ch/brixel-price-guarantee/',
    profileURL: 'https://dev-login.brixel.io/account/profile',
    sellUrl: 'https://brixel.ch/verkaufen/',
    sellUrlDe: 'https://brixel.ch/verkaufen/',
    shortPath: 'https://dev.api.brixel.io',
    signupUrl: 'https://dev-login.brixel.io/signup',
    transifexToken: '1/57348d40c1dcd3328d5ff327a88bba3705d5d61a',
    translationsUrl: 'https://dev.translations.brixel.io',
    messageTypeID: {
      contact: '5af32211ab72d0ca6a857361',
      schedule: '5af32211ab72d0ca6a857362',
      offer: '5af32211ab72d0ca6a857363'
    },
    domain: 'io',
    config: configLang['io'] || configLang['ch'],
    // LOGIN
    transifexIdLogin: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdLogin: 'UA-76350745-3',
    // GENERATOR
    transifexIdGenerator: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleID: 'GTM-T2D4XNW',
    googleTagID: 'G-DMC5SZJR39',
    googleAnalyticsIdGenerator: 'UA-76350745-3',
    googleMapsGenerator: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    // HUB
    transifexIdHub: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdHub: 'UA-76350745-3',
    googleMapsHub: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    // ADMIN
    transifexIdAdmin: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdAdmin: 'UA-76350745-3',
    googleMapsAdmin: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    // PAGE
    transifexIdPage: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdPage: 'UA-76350745-3',
    googleTagManagerPage: 'GTM-T2D4XNW',
    facebookPixelPage: '1803717239894086'
  },
  staging: {
    env: 'stage',
    craftCMS: 'https://cms.brixel.ch/',
    apiRoot: 'https://stage.api.brixel.io/api/v3',
    baseURL: 'https://stage-',
    shortPath: 'https://stage.api.brixel.io',
    apiPath: 'https://stage.api.brixel.io',
    pageUrl: 'https://stage-page.brixel.io/',
    hubUrl: 'https://stage-hub.brixel.io/',
    languages: _Constants.languagesList,
    homepageUrl: 'https://brixel.ch/',
    signupUrl: 'https://stage-login.brixel.io/signup',
    loginUrl: 'https://stage-login.brixel.io/login',
    logoutUrl: 'https://stage-login.brixel.io/logout',
    loginBasePath: 'https://stage-login.brixel.io',
    editorPath: 'https://stage-dashboard.brixel.io',
    dashboardPath: 'https://stage-hub.brixel.io',
    priceGuarantee: 'https://brixel.ch/brixel-price-guarantee/',
    buyUrl: 'https://brixel.ch/kaufen/',
    buyUrlDe: 'https://brixel.ch/kaufen/',
    sellUrl: 'https://brixel.ch/verkaufen/',
    sellUrlDe: 'https://brixel.ch/verkaufen/',
    estimationUrl: 'https://brixel.ch/bewerten/',
    aboutUsLink: 'https://brixel.ch/about-us',
    marketUrl: 'https://stage-market.brixel.io',
    googleLocation: 'https://maps.googleapis.com/maps/api/geocode',
    googleMaps: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    googleMapsGeocoderKey: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    transifexToken: '1/57348d40c1dcd3328d5ff327a88bba3705d5d61a',
    translationsUrl: 'https://stage.translations.brixel.io',
    hideLog: false,
    mixpanelId: '460b9387e3ff8b54da7bd974141e0f02',
    profileURL: 'https://stage-login.brixel.io/account/profile',
    messageTypeID: {
      contact: '584ec9043850e4852d0dbd1a',
      schedule: '584ec9153850e4852d0dbd1f',
      offer: '584ec9283850e4852d0dbd23'
    },
    domain: 'io',
    config: configLang['io'] || configLang['ch'],
    // LOGIN
    transifexIdLogin: 'b05987ca39b348bd8c3cbc766b10deec',
    googleAnalyticsIdLogin: 'UA-76350745-3',
    // GENERATOR
    transifexIdGenerator: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleID: 'GTM-T2D4XNW',
    googleTagID: 'G-DMC5SZJR39',
    googleAnalyticsIdGenerator: 'UA-76350745-3',
    googleMapsGenerator: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    // HUB
    transifexIdHub: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdHub: 'UA-76350745-3',
    googleMapsHub: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    // ADMIN
    transifexIdAdmin: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdAdmin: 'UA-76350745-3',
    googleMapsAdmin: 'AIzaSyD4tV7awt_UqVqk0vhyk3_zKi_RN--br5w',
    // PAGE
    transifexIdPage: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdPage: 'UA-76350745-3',
    googleTagManagerPage: 'GTM-T2D4XNW',
    facebookPixelPage: '1803717239894086'
  },
  production: {
    env: 'prod',
    craftCMS: 'https://cms.brixel.ch/',
    apiRoot: 'https://api.brixel.io/api/v3',
    baseURL: 'https://',
    shortPath: 'https://api.brixel.io',
    apiPath: 'https://api.brixel.io',
    pageUrl: 'https://page.brixel.io/',
    hubUrl: 'https://hub.brixel.io/',
    languages: _Constants.languagesList,
    homepageUrl: 'https://brixel.ch/',
    signupUrl: 'https://login.brixel.io/signup',
    loginUrl: 'https://login.brixel.io/login',
    logoutUrl: 'https://login.brixel.io/logout',
    loginBasePath: 'https://login.brixel.io',
    editorPath: 'https://dashboard.brixel.io',
    dashboardPath: 'https://hub.brixel.io',
    priceGuarantee: 'https://brixel.io/brixel-price-guarantee/',
    marketUrl: 'https://market.brixel.io',
    buyUrl: 'https://brixel.ch/kaufen/',
    buyUrlDe: 'https://brixel.ch/kaufen/',
    sellUrl: 'https://brixel.ch/verkaufen/',
    sellUrlDe: 'https://brixel.ch/verkaufen/',
    estimationUrl: 'https://brixel.ch/bewerten/',
    aboutUsLink: 'https://brixel.ch/about-us',
    googleLocation: 'https://maps.googleapis.com/maps/api/geocode',
    googleMaps: 'AIzaSyBnoc_7KMBePhoqGnIIN-YtTA6PCgjM968',
    googleMapsGeocoderKey: 'AIzaSyBnoc_7KMBePhoqGnIIN-YtTA6PCgjM968',
    transifexToken: '1/57348d40c1dcd3328d5ff327a88bba3705d5d61a',
    translationsUrl: 'https://translations.brixel.io',
    hideLog: true,
    mixpanelId: '460b9387e3ff8b54da7bd974141e0f02',
    profileURL: 'https://login.brixel.io/account/profile',
    messageTypeID: {
      contact: '58ab252051c9637267e6adec',
      schedule: '58ab252051c9637267e6aded',
      offer: '58ab252051c9637267e6adee'
    },
    domain: 'io',
    config: configLang['io'] || configLang['ch'],
    // LOGIN
    transifexIdLogin: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdLogin: 'UA-76350745-1',
    // GENERATOR
    transifexIdGenerator: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleID: 'GTM-TD3XNTN',
    googleTagID: 'G-1CM2QQ4RGD',
    googleAnalyticsIdGenerator: 'UA-76350745-1',
    googleMapsGenerator: 'AIzaSyBnoc_7KMBePhoqGnIIN-YtTA6PCgjM968',
    // HUB
    transifexIdHub: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdHub: 'UA-76350745-1',
    googleMapsHub: 'AIzaSyBnoc_7KMBePhoqGnIIN-YtTA6PCgjM968',
    // ADMIN
    transifexIdAdmin: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdAdmin: 'UA-76350745-1',
    googleMapsAdmin: 'AIzaSyBnoc_7KMBePhoqGnIIN-YtTA6PCgjM968',
    // PAGE
    transifexIdPage: 'e86c750b39de4c7e8c36a3b1ab7f98af',
    googleAnalyticsIdPage: 'UA-76350745-1',
    googleTagManagerPage: 'GTM-TD3XNTN',
    facebookPixelPage: '1803717239894086'
  }
};